import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { FixedSizeList } from 'react-window';
import memoize from 'memoize-one';
import CustomOption from './CustomOption.js';
import CustomOptionMulti from './CustomOptionMulti.js';
import MultiSelectHeader from './MultiSelectHeader.js';
import { useMenuListHeight } from './useMenuListHeight.js';
import 'lodash';
import '@elliemae/ds-separator';
import '@elliemae/ds-truncated-tooltip-text';
import '../context.js';
import '../../../Checkbox/DSCheckbox.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react-desc';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/utils';
import '../../../Checkbox/elements/CheckMark.js';
import 'styled-components';
import '../../../Checkbox/defaultProps.js';
import '../../../prop-types-cc01d273.js';
import '../../../Checkbox/props.js';
import '@elliemae/ds-button';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var createItemData = memoize(function (items, options) {
  if (items !== null && items !== void 0 && items.findIndex) {
    var index = items.findIndex(function (item) {
      return item.props.isFocused;
    });
    if (index > -1) return {
      items: items,
      options: options
    };
    return {
      items: [_objectSpread(_objectSpread({}, items[0]), {}, {
        props: _objectSpread(_objectSpread({}, items[0].props), {}, {
          isFocused: true
        })
      })].concat(_toConsumableArray(items.slice(1))),
      options: options
    };
  }

  return {
    items: items,
    options: options
  };
});

var scrollTo = function scrollTo(listRef, type) {
  if (listRef && listRef.current && listRef.current.props) {
    var items = listRef.current.props.itemData.items;
    var index = items.findIndex(function (item) {
      return item.props.isFocused;
    });
    listRef.current.scrollToItem(index !== -1 ? index : 0, type);
  }
};

var MenuList = /*#__PURE__*/React.memo(function (props) {
  var options = props.children,
      selectProps = props.selectProps,
      isMulti = props.isMulti,
      hasValue = props.hasValue;
  var customMenuItemOptions = selectProps.customMenuItemOptions,
      bottom = selectProps.selectMeasure.bounds.bottom;
  var listRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      inside = _useState2[0],
      setInside = _useState2[1];

  var remainingHeight = window.innerHeight - bottom - 10;
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      return window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  var handleKeyDown = function handleKeyDown() {
    return setInside(false);
  };

  var _customMenuItemOption = customMenuItemOptions.itemSize,
      itemSize = _customMenuItemOption === void 0 ? 35 : _customMenuItemOption,
      maxOptions = customMenuItemOptions.maxOptions;
  var itemData = createItemData(options, customMenuItemOptions);
  var RenderOption = !isMulti ? CustomOption : CustomOptionMulti;
  var height = useMenuListHeight(options, maxOptions, itemSize, remainingHeight);

  if (listRef && listRef.current && !inside && hasValue) {
    scrollTo(listRef); // use autoScroll
  }

  useEffect(function () {
    // fix this that has a bug where the groups is being focused
    if (hasValue && !inside && listRef) scrollTo(listRef);
  }, [options]);

  var setInsideFalseAtClosing = function setInsideFalseAtClosing() {
    return setInside(false);
  };

  useEffect(function () {
    return setInsideFalseAtClosing;
  }, []);
  if (!options.length) return /*#__PURE__*/React.createElement(components.MenuList, props);
  return /*#__PURE__*/React.createElement("div", {
    role: "list",
    "data-testid": "combobox-menu-list"
  }, isMulti && /*#__PURE__*/React.createElement(MultiSelectHeader, props), /*#__PURE__*/React.createElement(FixedSizeList, {
    ref: function ref(r) {
      listRef.current = r;

      if (!inside && listRef && hasValue) {
        scrollTo(listRef);
      }
    },
    className: "combobox-menu-list ".concat(isMulti && 'combobox-menu-list-is-multi'),
    height: height,
    itemCount: options.length,
    itemData: itemData,
    itemSize: itemSize,
    onScroll: function onScroll() {
      return setInside(true);
    },
    useIsScrolling: true
  }, RenderOption));
});
MenuList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  selectProps: PropTypes.object,
  isMulti: PropTypes.bool,
  hasValue: PropTypes.bool
};

export default MenuList;
//# sourceMappingURL=MenuList.js.map
